import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    line-height: 1.6;
    color: ${props => props.theme.colors.darkColor};
    background-color: #fff;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.secondary};
    font-weight: 700;
    margin-bottom: 1rem;
    color: ${props => props.theme.colors.secondaryColor};
  }

  a {
    text-decoration: none;
    color: ${props => props.theme.colors.primaryColor};
    transition: ${props => props.theme.transitions.main};
  }

  a:hover {
    color: ${props => props.theme.colors.secondaryColor};
  }

  img {
    max-width: 100%;
    height: auto;
  }

  ul, ol {
    list-style: none;
  }

  button {
    cursor: pointer;
    font-family: ${props => props.theme.fonts.primary};
  }

  input, textarea, select {
    font-family: ${props => props.theme.fonts.primary};
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }

  section {
    padding: 80px 0;
  }

  @media (max-width: 992px) {
    .container {
      max-width: 720px;
    }
  }

  @media (max-width: 768px) {
    .container {
      max-width: 540px;
    }
    
    section {
      padding: 60px 0;
    }
  }

  @media (max-width: 576px) {
    .container {
      max-width: 100%;
    }
    
    section {
      padding: 40px 0;
    }
  }
`;

export default GlobalStyles;
